/**
 * @generated SignedSource<<f84fe0e4df63e0993f394238a19f8316>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ECommerce = "AMAZON" | "API" | "BIG_COMMERCE" | "CODE_CANYON" | "C_CLOUD" | "ETSY" | "MAGENTO" | "MAGENTO1" | "NET_SUITE" | "NONE" | "OPEN_CART" | "PRESTA_SHOP" | "SHOPIFY" | "SHOPWARE" | "WIX" | "WOO_COMMERCE";
export type EmbeddedColorTypes = "CMYK" | "NONE" | "PANTONE";
export type ImageInsertScalingType = "AUTOFIT_SCALE_TO_COVER" | "AUTOFIT_SCALE_TO_FIT" | "SCALE_DOWN";
export type OutputMirrorPrintFiles = "BOTH" | "MIRROR_HORIZONTALLY" | "MIRROR_VERTICALLY" | "NONE" | "STANDARD_AND_BOTH" | "STANDARD_AND_MIRROR_HORIZONTALLY" | "STANDARD_AND_MIRROR_VERTICALLY";
export type ProductMirrorTypes = "COLORED" | "MIRRORED" | "NONE";
export type ProductProvider = "CASA_DE_LAS_CARCASAS" | "CUSTOM_CAT" | "FAVORITE_GIFT" | "HP" | "INVITION" | "PRINTFUL" | "PRINTFUL_DIRECT" | "UNDEFINED" | "VERSORI" | "ZAKEKE";
export type VectorizeOptionTypeEnum = "NONE" | "RASTER";
export type loadProductWithProductQuery$variables = {
  productId: string;
};
export type loadProductWithProductQuery$data = {
  readonly model: {
    readonly additionalCodes: ReadonlyArray<{
      readonly code: string;
      readonly merchantProductName: string;
      readonly salesChannel: {
        readonly ecommerceSettings: {
          readonly ecommerceName: ECommerce;
          readonly remoteUrl: string | null;
        } | null;
      };
      readonly salesChannelID: string;
    }>;
    readonly attributeGroups: ReadonlyArray<{
      readonly attributesAlwaysOpened: boolean;
      readonly direction: number;
      readonly displayOrder: number;
      readonly enabled: boolean;
      readonly groupGuid: any;
      readonly groupID: number;
      readonly imageUrl: string | null;
      readonly meshSelector: string | null;
      readonly name: string | null;
      readonly sceneCameraLocationID: any | null;
      readonly tempImageFileKey: string | null;
      readonly tempImageUrl: string | null;
    }>;
    readonly attributeSteps: ReadonlyArray<{
      readonly cameraLocationID: any | null;
      readonly displayOrder: number;
      readonly enabled: boolean;
      readonly groupGuid: any;
      readonly groupID: number;
      readonly name: string | null;
      readonly stepGuid: any;
      readonly stepID: number;
    }>;
    readonly attributes: ReadonlyArray<{
      readonly attributeCode: string | null;
      readonly attributeGuid: any;
      readonly attributeID: number | null;
      readonly attributeTypeID: number;
      readonly constraintExpression: {
        readonly expressions: ReadonlyArray<{
          readonly op: string | null;
          readonly propositions: ReadonlyArray<{
            readonly attributeGuid: any;
            readonly op: string | null;
            readonly value: string | null;
          } | null> | null;
        } | null> | null;
        readonly op: string | null;
        readonly propositions: ReadonlyArray<{
          readonly attributeGuid: any;
          readonly op: string | null;
          readonly value: string | null;
        } | null> | null;
      } | null;
      readonly defaultValue: string | null;
      readonly description: string | null;
      readonly displayOrder: number;
      readonly enabled: boolean;
      readonly groupGuid: any;
      readonly groupID: number;
      readonly hideOptionsLabel: boolean;
      readonly meshSelector: string | null;
      readonly name: string | null;
      readonly optionPreviewShapeID: number;
      readonly options: ReadonlyArray<{
        readonly actions: ReadonlyArray<{
          readonly actionGuid: any;
          readonly actionID: number;
          readonly actionTypeID: number;
          readonly deviceTypes: number;
          readonly enabled: boolean;
          readonly execOrder: number;
          readonly name: string | null;
          readonly propertyName: string | null;
          readonly sceneElementTypeID: number;
          readonly selector: string | null;
          readonly value: string | null;
        } | null> | null;
        readonly constraintExpression: {
          readonly expressions: ReadonlyArray<{
            readonly op: string | null;
            readonly propositions: ReadonlyArray<{
              readonly attributeGuid: any;
              readonly op: string | null;
              readonly value: string | null;
            } | null> | null;
          } | null> | null;
          readonly op: string | null;
          readonly propositions: ReadonlyArray<{
            readonly attributeGuid: any;
            readonly op: string | null;
            readonly value: string | null;
          } | null> | null;
        } | null;
        readonly description: string | null;
        readonly displayOrder: number;
        readonly enabled: boolean;
        readonly extensionFields: ReadonlyArray<{
          readonly dataTypeID: number;
          readonly extensionFieldID: number;
          readonly formatString: string | null;
          readonly label: string | null;
          readonly name: string | null;
          readonly operationTypeID: number;
          readonly value: string | null;
        } | null> | null;
        readonly imageFileObjectID: number;
        readonly imageUrl: string | null;
        readonly isDefault: boolean;
        readonly name: string | null;
        readonly optionCode: string | null;
        readonly optionGuid: any;
        readonly optionID: number | null;
        readonly tempImageFileKey: string | null;
        readonly tempImageFileObjectID: number;
      } | null> | null;
      readonly postActions: ReadonlyArray<{
        readonly actionGuid: any;
        readonly actionID: number;
        readonly actionTypeID: number;
        readonly deviceTypes: number;
        readonly enabled: boolean;
        readonly execOrder: number;
        readonly name: string | null;
        readonly propertyName: string | null;
        readonly sceneElementTypeID: number;
        readonly selector: string | null;
        readonly value: string | null;
      } | null> | null;
      readonly preActions: ReadonlyArray<{
        readonly actionGuid: any;
        readonly actionID: number;
        readonly actionTypeID: number;
        readonly deviceTypes: number;
        readonly enabled: boolean;
        readonly execOrder: number;
        readonly name: string | null;
        readonly propertyName: string | null;
        readonly sceneElementTypeID: number;
        readonly selector: string | null;
        readonly value: string | null;
      } | null> | null;
      readonly pricings: ReadonlyArray<{
        readonly attributePricingID: number;
        readonly constraintExpression: {
          readonly expressions: ReadonlyArray<{
            readonly op: string | null;
            readonly propositions: ReadonlyArray<{
              readonly attributeGuid: any;
              readonly op: string | null;
              readonly value: string | null;
            } | null> | null;
          } | null> | null;
          readonly op: string | null;
          readonly propositions: ReadonlyArray<{
            readonly attributeGuid: any;
            readonly op: string | null;
            readonly value: string | null;
          } | null> | null;
        } | null;
        readonly name: string | null;
        readonly price: number;
        readonly pricingID: number;
        readonly selectedOptionGuid: any | null;
        readonly selectedOptionID: number | null;
        readonly selectedValue: string | null;
      } | null> | null;
      readonly sceneCameraLocationID: any | null;
      readonly stepGuid: any;
      readonly stepID: number;
      readonly valueActions: ReadonlyArray<{
        readonly actionGuid: any;
        readonly actionID: number;
        readonly actionTypeID: number;
        readonly deviceTypes: number;
        readonly enabled: boolean;
        readonly execOrder: number;
        readonly name: string | null;
        readonly propertyName: string | null;
        readonly sceneElementTypeID: number;
        readonly selector: string | null;
        readonly value: string | null;
      } | null> | null;
    }>;
    readonly code: string;
    readonly colors: ReadonlyArray<{
      readonly code: string | null;
      readonly colorGuid: any;
      readonly colorID: number;
      readonly colorProviderCode: string | null;
      readonly name: string;
      readonly position: number;
      readonly sides: ReadonlyArray<{
        readonly areas: ReadonlyArray<{
          readonly areaID: number;
          readonly boundsHeight: number;
          readonly boundsWidth: number;
          readonly boundsX: number;
          readonly boundsY: number;
          readonly clipOut: boolean;
          readonly guid: string;
          readonly layers: ReadonlyArray<{
            readonly description: string;
            readonly displayName: string;
            readonly displayOrder: number;
            readonly isClipMask: boolean;
            readonly isOutputClipped: boolean;
            readonly isVisibleInCanvas: boolean;
            readonly isVisibleInCart: boolean;
            readonly isVisibleInOutput: boolean;
            readonly json: string;
            readonly layerID: any;
            readonly name: string;
            readonly showIn3DPreview: boolean;
            readonly showLabel: boolean;
            readonly svg: string;
          }>;
          readonly name: string;
          readonly path: string;
          readonly pathSVG: string;
          readonly templateFile: {
            readonly documentHeight: number;
            readonly documentWidth: number;
            readonly fileID: string | null;
            readonly fileObjectID: number;
          } | null;
        }>;
        readonly cameraLocationID: any | null;
        readonly canRotate: boolean | null;
        readonly code: string;
        readonly imageUrl: string;
        readonly mandatory: boolean;
        readonly name: string;
        readonly ppcm: number;
        readonly sideGuid: any | null;
        readonly sideID: number;
        readonly sortOrder: number | null;
        readonly tempImageFileKey: string | null;
      }>;
    }>;
    readonly defaultDesignTemplateID: number;
    readonly environment: number;
    readonly id: string;
    readonly isDemo: boolean;
    readonly largeImageUrl: string | null;
    readonly modelColorMappings: ReadonlyArray<{
      readonly colorID: number;
      readonly merchantCode: string;
      readonly salesChannelID: string;
    }>;
    readonly modelID: number;
    readonly name: string;
    readonly options: ReadonlyArray<{
      readonly colorID: number;
      readonly optionID: number;
      readonly optionsData: {
        readonly depth: number | null;
        readonly edgesColor: string | null;
        readonly is3DAutoGenEnabled: boolean;
        readonly isResizable: boolean;
        readonly isSplitOutput: boolean;
        readonly keepAspectRatio: boolean;
        readonly lockHeight: boolean;
        readonly lockWidth: boolean;
        readonly maxHeight: number | null;
        readonly maxWidth: number | null;
        readonly minHeight: number | null;
        readonly minSplitHeight: number | null;
        readonly minSplitWidth: number | null;
        readonly minWidth: number | null;
        readonly mirrorType: ProductMirrorTypes;
        readonly presets: ReadonlyArray<{
          readonly height: number;
          readonly name: string | null;
          readonly width: number;
        }>;
        readonly showHeightSize: boolean;
        readonly showSplitGrid: boolean;
        readonly showWidthSize: boolean;
        readonly startHeight: number | null;
        readonly startSplitColumns: number | null;
        readonly startSplitRows: number | null;
        readonly startWidth: number | null;
        readonly stepHeight: number | null;
        readonly stepWidth: number | null;
      };
      readonly sideID: number | null;
    }>;
    readonly preview3D: {
      readonly variantsAttributeOptions: {
        readonly attributeGuid: any;
        readonly variableMaterials: ReadonlyArray<{
          readonly materialID: string | null;
          readonly meshes: ReadonlyArray<string | null> | null;
        } | null> | null;
        readonly variantOptions: ReadonlyArray<{
          readonly materials: ReadonlyArray<{
            readonly actions: ReadonlyArray<{
              readonly actionGuid: any;
              readonly meshID: string | null;
            } | null> | null;
            readonly optionMaterialID: string | null;
            readonly variableMaterialID: string | null;
          } | null> | null;
          readonly meshes: ReadonlyArray<string | null> | null;
          readonly optionGuid: any;
          readonly variantID: string | null;
        } | null> | null;
      } | null;
    } | null;
    readonly pricingModelID: number;
    readonly printTypes: ReadonlyArray<{
      readonly canAddText: boolean | null;
      readonly canChangeSvgColors: boolean | null;
      readonly canIgnoreDPIWarning: boolean | null;
      readonly canUseImageFilters: boolean | null;
      readonly canUseTextArt: boolean | null;
      readonly defaultFontFamilyID: number | null;
      readonly disableImageColors: boolean | null;
      readonly disableSellerImages: boolean | null;
      readonly disableTextColors: boolean | null;
      readonly disableUserImages: boolean | null;
      readonly dpi: number | null;
      readonly fonts: ReadonlyArray<{
        readonly fontFamilyID: number;
        readonly fontFamilyName: string;
      }>;
      readonly imageColors: ReadonlyArray<{
        readonly colorCode: string;
        readonly isDefault: boolean;
      } | null> | null;
      readonly imageEditingToolSettingsToExclude: string | null;
      readonly name: string;
      readonly outputTypeID: number | null;
      readonly patID: number;
      readonly printTypeID: number;
      readonly printTypeRestrictions: {
        readonly allowAdaptText: boolean | null;
        readonly allowBold: boolean | null;
        readonly allowBottomVerticalAlignment: boolean | null;
        readonly allowCenterAlign: boolean | null;
        readonly allowChangeFontSize: boolean | null;
        readonly allowGradientTextColors: boolean;
        readonly allowImageGalleryTextColors: boolean;
        readonly allowImageResizeCliparts: boolean | null;
        readonly allowImageResizeUpload: boolean | null;
        readonly allowImageUploadTextColors: boolean;
        readonly allowItalic: boolean | null;
        readonly allowJustifyAlign: boolean | null;
        readonly allowLeftAlign: boolean | null;
        readonly allowLetterSpacing: boolean | null;
        readonly allowLineSpacing: boolean | null;
        readonly allowMiddleVerticalAlignment: boolean | null;
        readonly allowRightAlign: boolean | null;
        readonly allowShadows: boolean | null;
        readonly allowTextStroke: boolean | null;
        readonly allowTopVerticalAlignment: boolean | null;
        readonly canAddText: boolean | null;
        readonly canChangeSvgColors: boolean | null;
        readonly canIgnoreDPIWarning: boolean | null;
        readonly canPrintShadows: boolean;
        readonly canStretchImages: boolean | null;
        readonly canStretchTexts: boolean | null;
        readonly canUseImageFilters: boolean | null;
        readonly canUseTextArt: boolean | null;
        readonly convertAiToSvg: boolean | null;
        readonly convertEpsToSvg: boolean | null;
        readonly convertPdfToSvg: boolean | null;
        readonly createVectorizePreview: boolean;
        readonly curvedText: boolean | null;
        readonly defaultColor: string | null;
        readonly defaultFontFamilyID: number | null;
        readonly defaultFontSize: number | null;
        readonly defaultShadowAngle: number | null;
        readonly defaultShadowBlur: number | null;
        readonly defaultShadowColor: string | null;
        readonly defaultShadowDistance: number | null;
        readonly disableImageColors: boolean | null;
        readonly disableImageRotateCliparts: boolean | null;
        readonly disableImageRotateUpload: boolean | null;
        readonly disableSellerImages: boolean | null;
        readonly disableTextColors: boolean | null;
        readonly disableUserImages: boolean | null;
        readonly embeddedColorType: EmbeddedColorTypes;
        readonly embeddedPdf: boolean;
        readonly embeddedUseForRasterAlso: boolean;
        readonly enableVectorize: boolean;
        readonly fixedFontSize: number | null;
        readonly fontSizeList: ReadonlyArray<number> | null;
        readonly fonts: ReadonlyArray<{
          readonly fontFamilyID: number;
          readonly fontFamilyName: string;
        }> | null;
        readonly imageColors: ReadonlyArray<{
          readonly colorCode: string;
          readonly isDefault: boolean;
        }> | null;
        readonly imageEditingToolSettingsToExclude: string | null;
        readonly imageInsertScalingCliparts: ImageInsertScalingType | null;
        readonly imageInsertScalingUpload: ImageInsertScalingType | null;
        readonly isLargeFileEnabled: boolean;
        readonly maxFontSize: number | null;
        readonly maxHeightImageResizeCliparts: number | null;
        readonly maxHeightImageResizeUpload: number | null;
        readonly maxLetterSpacing: number | null;
        readonly maxLineSpacing: number | null;
        readonly maxNrImages: number | null;
        readonly maxNrTextElements: number | null;
        readonly maxShadowAngle: number | null;
        readonly maxShadowBlur: number | null;
        readonly maxShadowDistance: number | null;
        readonly maxTextStrokeWidth: number | null;
        readonly maxWidthImageResizeCliparts: number | null;
        readonly maxWidthImageResizeUpload: number | null;
        readonly minFontSize: number | null;
        readonly minHeightImageResizeCliparts: number | null;
        readonly minHeightImageResizeUpload: number | null;
        readonly minLetterSpacing: number | null;
        readonly minLineSpacing: number | null;
        readonly minShadowAngle: number | null;
        readonly minShadowBlur: number | null;
        readonly minShadowDistance: number | null;
        readonly minTextStrokeWidth: number | null;
        readonly minWidthImageResizeCliparts: number | null;
        readonly minWidthImageResizeUpload: number | null;
        readonly outputMirror: OutputMirrorPrintFiles | null;
        readonly shadowColors: ReadonlyArray<{
          readonly colorCode: string;
          readonly isDefault: boolean;
        }> | null;
        readonly showImageProvider: boolean | null;
        readonly showVectorizeModal: boolean;
        readonly textBox: boolean | null;
        readonly textColors: ReadonlyArray<{
          readonly colorCode: string;
          readonly isDefault: boolean;
        }> | null;
        readonly uploadRestrictions: {
          readonly isAiAllowed: boolean | null;
          readonly isEpsAllowed: boolean | null;
          readonly isFacebookAllowed: boolean | null;
          readonly isInstagramAllowed: boolean | null;
          readonly isJpgAllowed: boolean | null;
          readonly isPdfAllowed: boolean | null;
          readonly isPdfWithRasterAllowed: boolean | null;
          readonly isPngAllowed: boolean | null;
          readonly isSvgAllowed: boolean | null;
          readonly isUserImageAllowed: boolean | null;
          readonly resizeLargePdf: boolean | null;
        } | null;
        readonly uppercase: boolean | null;
        readonly useCustomFonts: boolean | null;
        readonly useImagesFixedSize: boolean | null;
        readonly vectorizeOption: VectorizeOptionTypeEnum;
      } | null;
      readonly printTypeRestrictionsID: number | null;
      readonly showImageProvider: boolean | null;
      readonly textColors: ReadonlyArray<{
        readonly colorCode: string;
        readonly isDefault: boolean;
      } | null> | null;
      readonly uploadRestrictions: {
        readonly isEpsAllowed: boolean | null;
        readonly isFacebookAllowed: boolean | null;
        readonly isInstagramAllowed: boolean | null;
        readonly isJpgAllowed: boolean | null;
        readonly isPdfAllowed: boolean | null;
        readonly isPdfWithRasterAllowed: boolean | null;
        readonly isPngAllowed: boolean | null;
        readonly isSvgAllowed: boolean | null;
        readonly isUserImageAllowed: boolean | null;
      } | null;
      readonly useCustomFonts: boolean | null;
      readonly useImagesFixedSize: boolean | null;
    }>;
    readonly provider: ProductProvider;
    readonly providerCode: string | null;
    readonly salesChannel: {
      readonly ecommerceSettings: {
        readonly ecommerceName: ECommerce;
      } | null;
    };
    readonly salesChannelID: string;
    readonly scenes: ReadonlyArray<{
      readonly isDefault: boolean;
      readonly meshDesignEffects: ReadonlyArray<{
        readonly config: {
          readonly diffuse: {
            readonly blendMode: string | null;
            readonly enabled: boolean;
            readonly level: number;
          } | null;
          readonly general: {
            readonly desktopTextureResolutionHeight: number | null;
            readonly desktopTextureResolutionWidth: number | null;
            readonly mobileTextureResolutionHeight: number | null;
            readonly mobileTextureResolutionWidth: number | null;
            readonly showDesign: boolean;
          } | null;
          readonly innerShadow: {
            readonly angle: number;
            readonly color: string | null;
            readonly distance: number;
            readonly enabled: boolean;
            readonly size: number;
          } | null;
          readonly normalmap: {
            readonly bevel: boolean;
            readonly bias: number;
            readonly enabled: boolean;
            readonly intensity: number;
            readonly invertG: boolean;
            readonly invertR: boolean;
            readonly postBlur: number;
            readonly postBlurEnabled: boolean;
            readonly preBlur: number;
            readonly preBlurEnabled: boolean;
            readonly showDesign: boolean;
            readonly showOnDesign: boolean;
            readonly showOnMesh: boolean;
          } | null;
          readonly opacity: {
            readonly enabled: boolean;
          } | null;
          readonly outerShadow: {
            readonly angle: number;
            readonly color: string | null;
            readonly distance: number;
            readonly enabled: boolean;
            readonly size: number;
          } | null;
        } | null;
        readonly effectID: any;
        readonly isDefault: boolean;
        readonly materialID: any | null;
        readonly meshID: any;
        readonly name: string | null;
        readonly subMeshID: number;
      }>;
      readonly meshSides: ReadonlyArray<{
        readonly attributeID: number | null;
        readonly colorID: number | null;
        readonly config: {
          readonly diffuse: {
            readonly blendMode: string | null;
            readonly enabled: boolean;
            readonly level: number;
          } | null;
          readonly general: {
            readonly desktopTextureResolutionHeight: number | null;
            readonly desktopTextureResolutionWidth: number | null;
            readonly mobileTextureResolutionHeight: number | null;
            readonly mobileTextureResolutionWidth: number | null;
            readonly showDesign: boolean;
          } | null;
          readonly innerShadow: {
            readonly angle: number;
            readonly color: string | null;
            readonly distance: number;
            readonly enabled: boolean;
            readonly size: number;
          } | null;
          readonly normalmap: {
            readonly bevel: boolean;
            readonly bias: number;
            readonly enabled: boolean;
            readonly intensity: number;
            readonly invertG: boolean;
            readonly invertR: boolean;
            readonly postBlur: number;
            readonly postBlurEnabled: boolean;
            readonly preBlur: number;
            readonly preBlurEnabled: boolean;
            readonly showDesign: boolean;
            readonly showOnDesign: boolean;
            readonly showOnMesh: boolean;
          } | null;
          readonly opacity: {
            readonly enabled: boolean;
          } | null;
          readonly outerShadow: {
            readonly angle: number;
            readonly color: string | null;
            readonly distance: number;
            readonly enabled: boolean;
            readonly size: number;
          } | null;
        } | null;
        readonly isNormalmapEnabled: boolean;
        readonly key: string | null;
        readonly materialID: any | null;
        readonly materialTexture: string | null;
        readonly matrix: string | null;
        readonly meshID: any;
        readonly percHeight: number;
        readonly percWidth: number;
        readonly sideID: number;
        readonly subMeshID: number;
        readonly transform: {
          readonly positionX: number;
          readonly positionY: number;
          readonly rotation: number;
          readonly scalingX: number;
          readonly scalingY: number;
        } | null;
        readonly uvChannel: number;
      }>;
      readonly sceneID: any;
    }>;
    readonly smallImageUrl: string;
    readonly sourceProductTemplateID: number | null;
    readonly statusID: number;
    readonly templateGroups: ReadonlyArray<{
      readonly categories: ReadonlyArray<{
        readonly categoryID: number;
        readonly macroCategoryID: number | null;
      } | null> | null;
      readonly compositions: ReadonlyArray<number> | null;
      readonly displayOrder: number;
      readonly groupGuid: any | null;
      readonly groupID: number | null;
      readonly macrocategories: ReadonlyArray<number> | null;
      readonly name: string | null;
      readonly stepGuid: any | null;
      readonly stepID: number | null;
      readonly templateGroupGuid: any | null;
      readonly templateGroupID: number | null;
    }>;
  } | null;
};
export type loadProductWithProductQuery = {
  response: loadProductWithProductQuery$data;
  variables: loadProductWithProductQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "productId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "productId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "modelID",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDemo",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "statusID",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "providerCode",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salesChannelID",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sourceProductTemplateID",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "defaultDesignTemplateID",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceName",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "merchantProductName",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remoteUrl",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "colorID",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "ModelColorMapping",
  "kind": "LinkedField",
  "name": "modelColorMappings",
  "plural": true,
  "selections": [
    (v15/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "merchantCode",
      "storageKey": null
    },
    (v9/*:: as any*/)
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pricingModelID",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "largeImageUrl",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "smallImageUrl",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "provider",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "environment",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "optionID",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sideID",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "ModelOption",
  "kind": "LinkedField",
  "name": "options",
  "plural": true,
  "selections": [
    (v22/*:: as any*/),
    (v15/*:: as any*/),
    (v23/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ModelOptionsData",
      "kind": "LinkedField",
      "name": "optionsData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isResizable",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "is3DAutoGenEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isSplitOutput",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startWidth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minWidth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxWidth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "stepWidth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startHeight",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minHeight",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxHeight",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "stepHeight",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "depth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "keepAspectRatio",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lockWidth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lockHeight",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showWidthSize",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showHeightSize",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showSplitGrid",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mirrorType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "edgesColor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minSplitWidth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minSplitHeight",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startSplitColumns",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "startSplitRows",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ModelOptionDataPresetData",
          "kind": "LinkedField",
          "name": "presets",
          "plural": true,
          "selections": [
            (v6/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "width",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "height",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "disableTextColors",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "disableImageColors",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "disableSellerImages",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "disableUserImages",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "useImagesFixedSize",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canAddText",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "useCustomFonts",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canChangeSvgColors",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canUseImageFilters",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canIgnoreDPIWarning",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageEditingToolSettingsToExclude",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showImageProvider",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "canUseTextArt",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "defaultFontFamilyID",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "concreteType": "PrintTypeFont",
  "kind": "LinkedField",
  "name": "fonts",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fontFamilyID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fontFamilyName",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDefault",
  "storageKey": null
},
v41 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "colorCode",
    "storageKey": null
  },
  (v40/*:: as any*/)
],
v42 = {
  "alias": null,
  "args": null,
  "concreteType": "RestrictionColor",
  "kind": "LinkedField",
  "name": "textColors",
  "plural": true,
  "selections": (v41/*:: as any*/),
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "RestrictionColor",
  "kind": "LinkedField",
  "name": "imageColors",
  "plural": true,
  "selections": (v41/*:: as any*/),
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isUserImageAllowed",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isJpgAllowed",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPngAllowed",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSvgAllowed",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPdfAllowed",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPdfWithRasterAllowed",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isEpsAllowed",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFacebookAllowed",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInstagramAllowed",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "concreteType": "ModelPrintType",
  "kind": "LinkedField",
  "name": "printTypes",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "printTypeID",
      "storageKey": null
    },
    (v6/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dpi",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "patID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "outputTypeID",
      "storageKey": null
    },
    (v25/*:: as any*/),
    (v26/*:: as any*/),
    (v27/*:: as any*/),
    (v28/*:: as any*/),
    (v29/*:: as any*/),
    (v30/*:: as any*/),
    (v31/*:: as any*/),
    (v32/*:: as any*/),
    (v33/*:: as any*/),
    (v34/*:: as any*/),
    (v35/*:: as any*/),
    (v36/*:: as any*/),
    (v37/*:: as any*/),
    (v38/*:: as any*/),
    (v39/*:: as any*/),
    (v42/*:: as any*/),
    (v43/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "UploadRestriction",
      "kind": "LinkedField",
      "name": "uploadRestrictions",
      "plural": false,
      "selections": [
        (v44/*:: as any*/),
        (v45/*:: as any*/),
        (v46/*:: as any*/),
        (v47/*:: as any*/),
        (v48/*:: as any*/),
        (v49/*:: as any*/),
        (v50/*:: as any*/),
        (v51/*:: as any*/),
        (v52/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "printTypeRestrictionsID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PartPrintTypeRestriction",
      "kind": "LinkedField",
      "name": "printTypeRestrictions",
      "plural": false,
      "selections": [
        (v25/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowGradientTextColors",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowImageUploadTextColors",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowImageGalleryTextColors",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "enableVectorize",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showVectorizeModal",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "vectorizeOption",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createVectorizePreview",
          "storageKey": null
        },
        (v26/*:: as any*/),
        (v27/*:: as any*/),
        (v28/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "embeddedColorType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "embeddedUseForRasterAlso",
          "storageKey": null
        },
        (v29/*:: as any*/),
        (v30/*:: as any*/),
        (v31/*:: as any*/),
        (v32/*:: as any*/),
        (v33/*:: as any*/),
        (v34/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canStretchImages",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canStretchTexts",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowImageResizeUpload",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minWidthImageResizeUpload",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxWidthImageResizeUpload",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minHeightImageResizeUpload",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxHeightImageResizeUpload",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowImageResizeCliparts",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minWidthImageResizeCliparts",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxWidthImageResizeCliparts",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minHeightImageResizeCliparts",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxHeightImageResizeCliparts",
          "storageKey": null
        },
        (v35/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageInsertScalingUpload",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "imageInsertScalingCliparts",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "disableImageRotateUpload",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "disableImageRotateCliparts",
          "storageKey": null
        },
        (v36/*:: as any*/),
        (v37/*:: as any*/),
        (v38/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "convertPdfToSvg",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "convertAiToSvg",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "convertEpsToSvg",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "curvedText",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowBold",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowItalic",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "uppercase",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxNrTextElements",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "defaultColor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowLeftAlign",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowCenterAlign",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowJustifyAlign",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowRightAlign",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxNrImages",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "textBox",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowLetterSpacing",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minLetterSpacing",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxLetterSpacing",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowLineSpacing",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minLineSpacing",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxLineSpacing",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowAdaptText",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowChangeFontSize",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minFontSize",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxFontSize",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fixedFontSize",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "fontSizeList",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "defaultFontSize",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowTopVerticalAlignment",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowMiddleVerticalAlignment",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowBottomVerticalAlignment",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowShadows",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canPrintShadows",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "defaultShadowColor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "defaultShadowBlur",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "defaultShadowDistance",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "defaultShadowAngle",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minShadowBlur",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxShadowBlur",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minShadowDistance",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxShadowDistance",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minShadowAngle",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxShadowAngle",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "outputMirror",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isLargeFileEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allowTextStroke",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minTextStrokeWidth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxTextStrokeWidth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "embeddedPdf",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RestrictionColor",
          "kind": "LinkedField",
          "name": "shadowColors",
          "plural": true,
          "selections": (v41/*:: as any*/),
          "storageKey": null
        },
        (v39/*:: as any*/),
        (v42/*:: as any*/),
        (v43/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "UploadRestriction",
          "kind": "LinkedField",
          "name": "uploadRestrictions",
          "plural": false,
          "selections": [
            (v44/*:: as any*/),
            (v45/*:: as any*/),
            (v46/*:: as any*/),
            (v47/*:: as any*/),
            (v48/*:: as any*/),
            (v49/*:: as any*/),
            (v50/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isAiAllowed",
              "storageKey": null
            },
            (v51/*:: as any*/),
            (v52/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "resizeLargePdf",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tempImageFileKey",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cameraLocationID",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayOrder",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "concreteType": "Color",
  "kind": "LinkedField",
  "name": "colors",
  "plural": true,
  "selections": [
    (v15/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "colorGuid",
      "storageKey": null
    },
    (v6/*:: as any*/),
    (v7/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "colorProviderCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "position",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Side",
      "kind": "LinkedField",
      "name": "sides",
      "plural": true,
      "selections": [
        (v23/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sideGuid",
          "storageKey": null
        },
        (v6/*:: as any*/),
        (v54/*:: as any*/),
        (v55/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ppcm",
          "storageKey": null
        },
        (v7/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sortOrder",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mandatory",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canRotate",
          "storageKey": null
        },
        (v56/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Area",
          "kind": "LinkedField",
          "name": "areas",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "areaID",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "boundsWidth",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "boundsHeight",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "boundsX",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "boundsY",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "path",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "pathSVG",
              "storageKey": null
            },
            (v6/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "clipOut",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "guid",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AreaLayer",
              "kind": "LinkedField",
              "name": "layers",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "layerID",
                  "storageKey": null
                },
                (v6/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayName",
                  "storageKey": null
                },
                (v57/*:: as any*/),
                (v58/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isVisibleInCanvas",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isVisibleInCart",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isVisibleInOutput",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "showLabel",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isClipMask",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isOutputClipped",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "showIn3DPreview",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "svg",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "json",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "AreaTemplateFile",
              "kind": "LinkedField",
              "name": "templateFile",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "fileID",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "fileObjectID",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "documentWidth",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "documentHeight",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meshID",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subMeshID",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "materialID",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showDesign",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enabled",
  "storageKey": null
},
v65 = [
  (v64/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "color",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "angle",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "distance",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "size",
    "storageKey": null
  }
],
v66 = {
  "alias": null,
  "args": null,
  "concreteType": "MeshDesignConfig",
  "kind": "LinkedField",
  "name": "config",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MeshDesignGeneralConfig",
      "kind": "LinkedField",
      "name": "general",
      "plural": false,
      "selections": [
        (v63/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "desktopTextureResolutionWidth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "desktopTextureResolutionHeight",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mobileTextureResolutionWidth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mobileTextureResolutionHeight",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DiffuseConfig",
      "kind": "LinkedField",
      "name": "diffuse",
      "plural": false,
      "selections": [
        (v64/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "blendMode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "level",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OpacityConfig",
      "kind": "LinkedField",
      "name": "opacity",
      "plural": false,
      "selections": [
        (v64/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NormalmapConfig",
      "kind": "LinkedField",
      "name": "normalmap",
      "plural": false,
      "selections": [
        (v64/*:: as any*/),
        (v63/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showOnDesign",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showOnMesh",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bias",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "invertR",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "invertG",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "preBlurEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "preBlur",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "postBlurEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "postBlur",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "intensity",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "bevel",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OuterShadowConfig",
      "kind": "LinkedField",
      "name": "outerShadow",
      "plural": false,
      "selections": (v65/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "InnerShadowConfig",
      "kind": "LinkedField",
      "name": "innerShadow",
      "plural": false,
      "selections": (v65/*:: as any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v67 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "attributeID",
  "storageKey": null
},
v68 = {
  "alias": null,
  "args": null,
  "concreteType": "ModelScene",
  "kind": "LinkedField",
  "name": "scenes",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sceneID",
      "storageKey": null
    },
    (v40/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ModelSceneMeshDesignEffect",
      "kind": "LinkedField",
      "name": "meshDesignEffects",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "effectID",
          "storageKey": null
        },
        (v60/*:: as any*/),
        (v61/*:: as any*/),
        (v6/*:: as any*/),
        (v62/*:: as any*/),
        (v40/*:: as any*/),
        (v66/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ModelSceneMeshSide",
      "kind": "LinkedField",
      "name": "meshSides",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        (v60/*:: as any*/),
        (v61/*:: as any*/),
        (v23/*:: as any*/),
        (v15/*:: as any*/),
        (v67/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "matrix",
          "storageKey": null
        },
        (v62/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "materialTexture",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isNormalmapEnabled",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "percWidth",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "percHeight",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "uvChannel",
          "storageKey": null
        },
        (v66/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Transform",
          "kind": "LinkedField",
          "name": "transform",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "positionX",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "positionY",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "scalingX",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "scalingY",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "rotation",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "attributeGuid",
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meshes",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "optionGuid",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actionGuid",
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "concreteType": "Preview3D",
  "kind": "LinkedField",
  "name": "preview3D",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "VariantsAttributeOptions",
      "kind": "LinkedField",
      "name": "variantsAttributeOptions",
      "plural": false,
      "selections": [
        (v69/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "VariableMaterial",
          "kind": "LinkedField",
          "name": "variableMaterials",
          "plural": true,
          "selections": [
            (v62/*:: as any*/),
            (v70/*:: as any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "VariantOption",
          "kind": "LinkedField",
          "name": "variantOptions",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "variantID",
              "storageKey": null
            },
            (v71/*:: as any*/),
            (v70/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "VariantOptionMaterial",
              "kind": "LinkedField",
              "name": "materials",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "optionMaterialID",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "variableMaterialID",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "VariantOptionMaterialAction",
                  "kind": "LinkedField",
                  "name": "actions",
                  "plural": true,
                  "selections": [
                    (v72/*:: as any*/),
                    (v60/*:: as any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "attributeCode",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "attributeTypeID",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "defaultValue",
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "groupID",
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "groupGuid",
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stepID",
  "storageKey": null
},
v80 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stepGuid",
  "storageKey": null
},
v81 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "optionPreviewShapeID",
  "storageKey": null
},
v82 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "meshSelector",
  "storageKey": null
},
v83 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sceneCameraLocationID",
  "storageKey": null
},
v84 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hideOptionsLabel",
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "op",
  "storageKey": null
},
v86 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeProposition",
  "kind": "LinkedField",
  "name": "propositions",
  "plural": true,
  "selections": [
    (v69/*:: as any*/),
    (v85/*:: as any*/),
    (v86/*:: as any*/)
  ],
  "storageKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeExpression",
  "kind": "LinkedField",
  "name": "expressions",
  "plural": true,
  "selections": [
    (v85/*:: as any*/),
    (v87/*:: as any*/)
  ],
  "storageKey": null
},
v89 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeExpression",
  "kind": "LinkedField",
  "name": "constraintExpression",
  "plural": false,
  "selections": [
    (v87/*:: as any*/),
    (v85/*:: as any*/),
    (v88/*:: as any*/)
  ],
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeExpression",
  "kind": "LinkedField",
  "name": "constraintExpression",
  "plural": false,
  "selections": [
    (v85/*:: as any*/),
    (v87/*:: as any*/),
    (v88/*:: as any*/)
  ],
  "storageKey": null
},
v91 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributePricing",
  "kind": "LinkedField",
  "name": "pricings",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "attributePricingID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "selectedOptionID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "selectedOptionGuid",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "selectedValue",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "price",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "pricingID",
      "storageKey": null
    },
    (v6/*:: as any*/),
    (v90/*:: as any*/)
  ],
  "storageKey": null
},
v92 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "actionID",
    "storageKey": null
  },
  (v72/*:: as any*/),
  (v6/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "actionTypeID",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sceneElementTypeID",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "selector",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "propertyName",
    "storageKey": null
  },
  (v86/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "execOrder",
    "storageKey": null
  },
  (v64/*:: as any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "deviceTypes",
    "storageKey": null
  }
],
v93 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeSceneAction",
  "kind": "LinkedField",
  "name": "preActions",
  "plural": true,
  "selections": (v92/*:: as any*/),
  "storageKey": null
},
v94 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeSceneAction",
  "kind": "LinkedField",
  "name": "valueActions",
  "plural": true,
  "selections": (v92/*:: as any*/),
  "storageKey": null
},
v95 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeSceneAction",
  "kind": "LinkedField",
  "name": "postActions",
  "plural": true,
  "selections": (v92/*:: as any*/),
  "storageKey": null
},
v96 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeOption",
  "kind": "LinkedField",
  "name": "options",
  "plural": true,
  "selections": [
    (v22/*:: as any*/),
    (v71/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "optionCode",
      "storageKey": null
    },
    (v54/*:: as any*/),
    (v55/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tempImageFileObjectID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "imageFileObjectID",
      "storageKey": null
    },
    (v6/*:: as any*/),
    (v57/*:: as any*/),
    (v58/*:: as any*/),
    (v64/*:: as any*/),
    (v40/*:: as any*/),
    (v90/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "AttributeSceneAction",
      "kind": "LinkedField",
      "name": "actions",
      "plural": true,
      "selections": (v92/*:: as any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AttributeOptionExtensionField",
      "kind": "LinkedField",
      "name": "extensionFields",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "extensionFieldID",
          "storageKey": null
        },
        (v86/*:: as any*/),
        (v6/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "label",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "formatString",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dataTypeID",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "operationTypeID",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v97 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeStep",
  "kind": "LinkedField",
  "name": "attributeSteps",
  "plural": true,
  "selections": [
    (v79/*:: as any*/),
    (v80/*:: as any*/),
    (v77/*:: as any*/),
    (v78/*:: as any*/),
    (v6/*:: as any*/),
    (v58/*:: as any*/),
    (v64/*:: as any*/),
    (v56/*:: as any*/)
  ],
  "storageKey": null
},
v98 = {
  "alias": null,
  "args": null,
  "concreteType": "TemplateGroup",
  "kind": "LinkedField",
  "name": "templateGroups",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "templateGroupID",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "templateGroupGuid",
      "storageKey": null
    },
    (v6/*:: as any*/),
    (v58/*:: as any*/),
    (v77/*:: as any*/),
    (v78/*:: as any*/),
    (v79/*:: as any*/),
    (v80/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "compositions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "macrocategories",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CategoryMacroCategoryIds",
      "kind": "LinkedField",
      "name": "categories",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "categoryID",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "macroCategoryID",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeGroup",
  "kind": "LinkedField",
  "name": "attributeGroups",
  "plural": true,
  "selections": [
    (v77/*:: as any*/),
    (v78/*:: as any*/),
    (v54/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tempImageUrl",
      "storageKey": null
    },
    (v55/*:: as any*/),
    (v6/*:: as any*/),
    (v58/*:: as any*/),
    (v64/*:: as any*/),
    (v83/*:: as any*/),
    (v82/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "direction",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "attributesAlwaysOpened",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "loadProductWithProductQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Model",
        "kind": "LinkedField",
        "name": "model",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          (v7/*:: as any*/),
          (v8/*:: as any*/),
          (v9/*:: as any*/),
          (v10/*:: as any*/),
          (v11/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SalesChannel",
            "kind": "LinkedField",
            "name": "salesChannel",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EcommerceSettings",
                "kind": "LinkedField",
                "name": "ecommerceSettings",
                "plural": false,
                "selections": [
                  (v12/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductCode",
            "kind": "LinkedField",
            "name": "additionalCodes",
            "plural": true,
            "selections": [
              (v7/*:: as any*/),
              (v9/*:: as any*/),
              (v13/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SalesChannel",
                "kind": "LinkedField",
                "name": "salesChannel",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EcommerceSettings",
                    "kind": "LinkedField",
                    "name": "ecommerceSettings",
                    "plural": false,
                    "selections": [
                      (v12/*:: as any*/),
                      (v14/*:: as any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v16/*:: as any*/),
          (v17/*:: as any*/),
          (v18/*:: as any*/),
          (v19/*:: as any*/),
          (v20/*:: as any*/),
          (v21/*:: as any*/),
          (v24/*:: as any*/),
          (v53/*:: as any*/),
          (v59/*:: as any*/),
          (v68/*:: as any*/),
          (v73/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Attribute",
            "kind": "LinkedField",
            "name": "attributes",
            "plural": true,
            "selections": [
              (v67/*:: as any*/),
              (v69/*:: as any*/),
              (v74/*:: as any*/),
              (v75/*:: as any*/),
              (v76/*:: as any*/),
              (v58/*:: as any*/),
              (v64/*:: as any*/),
              (v6/*:: as any*/),
              (v57/*:: as any*/),
              (v77/*:: as any*/),
              (v78/*:: as any*/),
              (v79/*:: as any*/),
              (v80/*:: as any*/),
              (v81/*:: as any*/),
              (v82/*:: as any*/),
              (v83/*:: as any*/),
              (v84/*:: as any*/),
              (v89/*:: as any*/),
              (v91/*:: as any*/),
              (v93/*:: as any*/),
              (v94/*:: as any*/),
              (v95/*:: as any*/),
              (v96/*:: as any*/)
            ],
            "storageKey": null
          },
          (v97/*:: as any*/),
          (v98/*:: as any*/),
          (v99/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "loadProductWithProductQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Model",
        "kind": "LinkedField",
        "name": "model",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          (v5/*:: as any*/),
          (v6/*:: as any*/),
          (v7/*:: as any*/),
          (v8/*:: as any*/),
          (v9/*:: as any*/),
          (v10/*:: as any*/),
          (v11/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SalesChannel",
            "kind": "LinkedField",
            "name": "salesChannel",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EcommerceSettings",
                "kind": "LinkedField",
                "name": "ecommerceSettings",
                "plural": false,
                "selections": [
                  (v12/*:: as any*/),
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ProductCode",
            "kind": "LinkedField",
            "name": "additionalCodes",
            "plural": true,
            "selections": [
              (v7/*:: as any*/),
              (v9/*:: as any*/),
              (v13/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SalesChannel",
                "kind": "LinkedField",
                "name": "salesChannel",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "EcommerceSettings",
                    "kind": "LinkedField",
                    "name": "ecommerceSettings",
                    "plural": false,
                    "selections": [
                      (v12/*:: as any*/),
                      (v14/*:: as any*/),
                      (v2/*:: as any*/)
                    ],
                    "storageKey": null
                  },
                  (v2/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v16/*:: as any*/),
          (v17/*:: as any*/),
          (v18/*:: as any*/),
          (v19/*:: as any*/),
          (v20/*:: as any*/),
          (v21/*:: as any*/),
          (v24/*:: as any*/),
          (v53/*:: as any*/),
          (v59/*:: as any*/),
          (v68/*:: as any*/),
          (v73/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Attribute",
            "kind": "LinkedField",
            "name": "attributes",
            "plural": true,
            "selections": [
              (v67/*:: as any*/),
              (v69/*:: as any*/),
              (v74/*:: as any*/),
              (v75/*:: as any*/),
              (v76/*:: as any*/),
              (v58/*:: as any*/),
              (v64/*:: as any*/),
              (v6/*:: as any*/),
              (v57/*:: as any*/),
              (v77/*:: as any*/),
              (v78/*:: as any*/),
              (v79/*:: as any*/),
              (v80/*:: as any*/),
              (v81/*:: as any*/),
              (v82/*:: as any*/),
              (v83/*:: as any*/),
              (v84/*:: as any*/),
              (v89/*:: as any*/),
              (v91/*:: as any*/),
              (v93/*:: as any*/),
              (v94/*:: as any*/),
              (v95/*:: as any*/),
              (v96/*:: as any*/),
              (v2/*:: as any*/)
            ],
            "storageKey": null
          },
          (v97/*:: as any*/),
          (v98/*:: as any*/),
          (v99/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a2c401d05e0c3eec83671b57855f2d79",
    "id": null,
    "metadata": {},
    "name": "loadProductWithProductQuery",
    "operationKind": "query",
    "text": "query loadProductWithProductQuery(\n  $productId: ID!\n) {\n  model(id: $productId) {\n    id\n    modelID\n    isDemo\n    statusID\n    name\n    code\n    providerCode\n    salesChannelID\n    sourceProductTemplateID\n    defaultDesignTemplateID\n    salesChannel {\n      ecommerceSettings {\n        ecommerceName\n        id\n      }\n      id\n    }\n    additionalCodes {\n      code\n      salesChannelID\n      merchantProductName\n      salesChannel {\n        ecommerceSettings {\n          ecommerceName\n          remoteUrl\n          id\n        }\n        id\n      }\n    }\n    modelColorMappings {\n      colorID\n      merchantCode\n      salesChannelID\n    }\n    pricingModelID\n    largeImageUrl\n    smallImageUrl\n    provider\n    environment\n    options {\n      optionID\n      colorID\n      sideID\n      optionsData {\n        isResizable\n        is3DAutoGenEnabled\n        isSplitOutput\n        startWidth\n        minWidth\n        maxWidth\n        stepWidth\n        startHeight\n        minHeight\n        maxHeight\n        stepHeight\n        depth\n        keepAspectRatio\n        lockWidth\n        lockHeight\n        showWidthSize\n        showHeightSize\n        showSplitGrid\n        mirrorType\n        edgesColor\n        minSplitWidth\n        minSplitHeight\n        startSplitColumns\n        startSplitRows\n        presets {\n          name\n          width\n          height\n        }\n      }\n    }\n    printTypes {\n      printTypeID\n      name\n      dpi\n      patID\n      outputTypeID\n      disableTextColors\n      disableImageColors\n      disableSellerImages\n      disableUserImages\n      useImagesFixedSize\n      canAddText\n      useCustomFonts\n      canChangeSvgColors\n      canUseImageFilters\n      canIgnoreDPIWarning\n      imageEditingToolSettingsToExclude\n      showImageProvider\n      canUseTextArt\n      defaultFontFamilyID\n      fonts {\n        fontFamilyID\n        fontFamilyName\n      }\n      textColors {\n        colorCode\n        isDefault\n      }\n      imageColors {\n        colorCode\n        isDefault\n      }\n      uploadRestrictions {\n        isUserImageAllowed\n        isJpgAllowed\n        isPngAllowed\n        isSvgAllowed\n        isPdfAllowed\n        isPdfWithRasterAllowed\n        isEpsAllowed\n        isFacebookAllowed\n        isInstagramAllowed\n      }\n      printTypeRestrictionsID\n      printTypeRestrictions {\n        disableTextColors\n        allowGradientTextColors\n        allowImageUploadTextColors\n        allowImageGalleryTextColors\n        enableVectorize\n        showVectorizeModal\n        vectorizeOption\n        createVectorizePreview\n        disableImageColors\n        disableSellerImages\n        disableUserImages\n        embeddedColorType\n        embeddedUseForRasterAlso\n        useImagesFixedSize\n        canAddText\n        useCustomFonts\n        canChangeSvgColors\n        canUseImageFilters\n        canIgnoreDPIWarning\n        canStretchImages\n        canStretchTexts\n        allowImageResizeUpload\n        minWidthImageResizeUpload\n        maxWidthImageResizeUpload\n        minHeightImageResizeUpload\n        maxHeightImageResizeUpload\n        allowImageResizeCliparts\n        minWidthImageResizeCliparts\n        maxWidthImageResizeCliparts\n        minHeightImageResizeCliparts\n        maxHeightImageResizeCliparts\n        imageEditingToolSettingsToExclude\n        imageInsertScalingUpload\n        imageInsertScalingCliparts\n        disableImageRotateUpload\n        disableImageRotateCliparts\n        showImageProvider\n        canUseTextArt\n        defaultFontFamilyID\n        convertPdfToSvg\n        convertAiToSvg\n        convertEpsToSvg\n        curvedText\n        allowBold\n        allowItalic\n        uppercase\n        maxNrTextElements\n        defaultColor\n        allowLeftAlign\n        allowCenterAlign\n        allowJustifyAlign\n        allowRightAlign\n        maxNrImages\n        textBox\n        allowLetterSpacing\n        minLetterSpacing\n        maxLetterSpacing\n        allowLineSpacing\n        minLineSpacing\n        maxLineSpacing\n        allowAdaptText\n        allowChangeFontSize\n        minFontSize\n        maxFontSize\n        fixedFontSize\n        fontSizeList\n        defaultFontSize\n        allowTopVerticalAlignment\n        allowMiddleVerticalAlignment\n        allowBottomVerticalAlignment\n        allowShadows\n        canPrintShadows\n        defaultShadowColor\n        defaultShadowBlur\n        defaultShadowDistance\n        defaultShadowAngle\n        minShadowBlur\n        maxShadowBlur\n        minShadowDistance\n        maxShadowDistance\n        minShadowAngle\n        maxShadowAngle\n        outputMirror\n        isLargeFileEnabled\n        allowTextStroke\n        minTextStrokeWidth\n        maxTextStrokeWidth\n        embeddedPdf\n        shadowColors {\n          colorCode\n          isDefault\n        }\n        fonts {\n          fontFamilyID\n          fontFamilyName\n        }\n        textColors {\n          colorCode\n          isDefault\n        }\n        imageColors {\n          colorCode\n          isDefault\n        }\n        uploadRestrictions {\n          isUserImageAllowed\n          isJpgAllowed\n          isPngAllowed\n          isSvgAllowed\n          isPdfAllowed\n          isPdfWithRasterAllowed\n          isEpsAllowed\n          isAiAllowed\n          isFacebookAllowed\n          isInstagramAllowed\n          resizeLargePdf\n        }\n      }\n    }\n    colors {\n      colorID\n      colorGuid\n      name\n      code\n      colorProviderCode\n      position\n      sides {\n        sideID\n        sideGuid\n        name\n        tempImageFileKey\n        imageUrl\n        ppcm\n        code\n        sortOrder\n        mandatory\n        canRotate\n        cameraLocationID\n        areas {\n          areaID\n          boundsWidth\n          boundsHeight\n          boundsX\n          boundsY\n          path\n          pathSVG\n          name\n          clipOut\n          guid\n          layers {\n            layerID\n            name\n            displayName\n            description\n            displayOrder\n            isVisibleInCanvas\n            isVisibleInCart\n            isVisibleInOutput\n            showLabel\n            isClipMask\n            isOutputClipped\n            showIn3DPreview\n            svg\n            json\n          }\n          templateFile {\n            fileID\n            fileObjectID\n            documentWidth\n            documentHeight\n          }\n        }\n      }\n    }\n    scenes {\n      sceneID\n      isDefault\n      meshDesignEffects {\n        effectID\n        meshID\n        subMeshID\n        name\n        materialID\n        isDefault\n        config {\n          general {\n            showDesign\n            desktopTextureResolutionWidth\n            desktopTextureResolutionHeight\n            mobileTextureResolutionWidth\n            mobileTextureResolutionHeight\n          }\n          diffuse {\n            enabled\n            blendMode\n            level\n          }\n          opacity {\n            enabled\n          }\n          normalmap {\n            enabled\n            showDesign\n            showOnDesign\n            showOnMesh\n            bias\n            invertR\n            invertG\n            preBlurEnabled\n            preBlur\n            postBlurEnabled\n            postBlur\n            intensity\n            bevel\n          }\n          outerShadow {\n            enabled\n            color\n            angle\n            distance\n            size\n          }\n          innerShadow {\n            enabled\n            color\n            angle\n            distance\n            size\n          }\n        }\n      }\n      meshSides {\n        key\n        meshID\n        subMeshID\n        sideID\n        colorID\n        attributeID\n        matrix\n        materialID\n        materialTexture\n        isNormalmapEnabled\n        percWidth\n        percHeight\n        uvChannel\n        config {\n          general {\n            showDesign\n            desktopTextureResolutionWidth\n            desktopTextureResolutionHeight\n            mobileTextureResolutionWidth\n            mobileTextureResolutionHeight\n          }\n          diffuse {\n            enabled\n            blendMode\n            level\n          }\n          opacity {\n            enabled\n          }\n          normalmap {\n            enabled\n            showDesign\n            showOnDesign\n            showOnMesh\n            bias\n            invertR\n            invertG\n            preBlurEnabled\n            preBlur\n            postBlurEnabled\n            postBlur\n            intensity\n            bevel\n          }\n          outerShadow {\n            enabled\n            color\n            angle\n            distance\n            size\n          }\n          innerShadow {\n            enabled\n            color\n            angle\n            distance\n            size\n          }\n        }\n        transform {\n          positionX\n          positionY\n          scalingX\n          scalingY\n          rotation\n        }\n      }\n    }\n    preview3D {\n      variantsAttributeOptions {\n        attributeGuid\n        variableMaterials {\n          materialID\n          meshes\n        }\n        variantOptions {\n          variantID\n          optionGuid\n          meshes\n          materials {\n            optionMaterialID\n            variableMaterialID\n            actions {\n              actionGuid\n              meshID\n            }\n          }\n        }\n      }\n    }\n    attributes {\n      attributeID\n      attributeGuid\n      attributeCode\n      attributeTypeID\n      defaultValue\n      displayOrder\n      enabled\n      name\n      description\n      groupID\n      groupGuid\n      stepID\n      stepGuid\n      optionPreviewShapeID\n      meshSelector\n      sceneCameraLocationID\n      hideOptionsLabel\n      constraintExpression {\n        propositions {\n          attributeGuid\n          op\n          value\n        }\n        op\n        expressions {\n          op\n          propositions {\n            attributeGuid\n            op\n            value\n          }\n        }\n      }\n      pricings {\n        attributePricingID\n        selectedOptionID\n        selectedOptionGuid\n        selectedValue\n        price\n        pricingID\n        name\n        constraintExpression {\n          op\n          propositions {\n            attributeGuid\n            op\n            value\n          }\n          expressions {\n            op\n            propositions {\n              attributeGuid\n              op\n              value\n            }\n          }\n        }\n      }\n      preActions {\n        actionID\n        actionGuid\n        name\n        actionTypeID\n        sceneElementTypeID\n        selector\n        propertyName\n        value\n        execOrder\n        enabled\n        deviceTypes\n      }\n      valueActions {\n        actionID\n        actionGuid\n        name\n        actionTypeID\n        sceneElementTypeID\n        selector\n        propertyName\n        value\n        execOrder\n        enabled\n        deviceTypes\n      }\n      postActions {\n        actionID\n        actionGuid\n        name\n        actionTypeID\n        sceneElementTypeID\n        selector\n        propertyName\n        value\n        execOrder\n        enabled\n        deviceTypes\n      }\n      options {\n        optionID\n        optionGuid\n        optionCode\n        tempImageFileKey\n        imageUrl\n        tempImageFileObjectID\n        imageFileObjectID\n        name\n        description\n        displayOrder\n        enabled\n        isDefault\n        constraintExpression {\n          op\n          propositions {\n            attributeGuid\n            op\n            value\n          }\n          expressions {\n            op\n            propositions {\n              attributeGuid\n              op\n              value\n            }\n          }\n        }\n        actions {\n          actionID\n          actionGuid\n          name\n          actionTypeID\n          sceneElementTypeID\n          selector\n          propertyName\n          value\n          execOrder\n          enabled\n          deviceTypes\n        }\n        extensionFields {\n          extensionFieldID\n          value\n          name\n          label\n          formatString\n          dataTypeID\n          operationTypeID\n        }\n      }\n      id\n    }\n    attributeSteps {\n      stepID\n      stepGuid\n      groupID\n      groupGuid\n      name\n      displayOrder\n      enabled\n      cameraLocationID\n    }\n    templateGroups {\n      templateGroupID\n      templateGroupGuid\n      name\n      displayOrder\n      groupID\n      groupGuid\n      stepID\n      stepGuid\n      compositions\n      macrocategories\n      categories {\n        categoryID\n        macroCategoryID\n      }\n    }\n    attributeGroups {\n      groupID\n      groupGuid\n      tempImageFileKey\n      tempImageUrl\n      imageUrl\n      name\n      displayOrder\n      enabled\n      sceneCameraLocationID\n      meshSelector\n      direction\n      attributesAlwaysOpened\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d3d3ae89173c00a5c4859d85a151e35a";

export default node;
